export default __webpack_public_path__ + "static/media/typicalweek (3).3a9baac4.png";